import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import FinancialProductGeneralDataContainer from './generalData/FinancialProductGeneralDataContainer';
import FinancialProductDetailsContainer from './details/FinancialProductDetailsContainer';
import { FINANCIAL_PRODUCT_QUERY, GENERIC_ENTITY_BUSINESS_STATES_FLOW_QUERY, GENERIC_ENTITY_FLOWS_QUERY } from '../queries';
import { useQuery } from 'hooks/apollo';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import useLanguageTracker from 'hooks/useLanguageTracker';

const FinancialProductContainer = ({ canWrite, productId, onRedirect, onChangeTitle }) => {
  const [generalDataLens, setGeneralDataLens] = useState({});

  const { data, loading, refetch } = useQuery(FINANCIAL_PRODUCT_QUERY, {
    variables: { productId },
    skip: !productId
  });

  const { data: genericEntityFlowsData } = useQuery(GENERIC_ENTITY_FLOWS_QUERY, {
    variables: { context: 'FINANCIAL_PRODUCT' }
  });

  const mainFlow = useMemo(
    () => genericEntityFlowsData?.genericEntityFlowsDictionary.find(item => item.mainFlow),
    [genericEntityFlowsData]
  );

  const { data: states } = useQuery(GENERIC_ENTITY_BUSINESS_STATES_FLOW_QUERY, {
    variables: { flowId: data?.financialProduct?.financialProductXBusinessFlow?.flowId ?? mainFlow?.id },
    skip: !data?.financialProduct?.financialProductXBusinessFlow && !mainFlow?.id
  });

  const newFinancialProductState = useMemo(() => {
    let activeState = states?.genericEntityBusinessStatesXFlow?.find(item => item.isInitialState);
    const financialProductStateId = data?.financialProduct?.financialProductXBusinessFlow?.currentStateId;
    if (financialProductStateId) activeState = states?.genericEntityBusinessStatesXFlow?.find(item => item.id === financialProductStateId);
    if (activeState) {
      return {
        stateId: activeState.id,
        stateName: activeState.name,
        editableYN: activeState.editableYN
      };
    }
    return { stateId: null, stateName: '', editableYN: false };
  }, [states, data?.financialProduct]);

  const onLanguageChange = useCallback(() => {
    refetch();
  }, [refetch]);

  useLanguageTracker({
    onChange: onLanguageChange
  });

  return (
    <>
      {loading ? (
        <Card>
          <FakeText lines={15} />
        </Card>
      ) : (
        <>
          <FinancialProductGeneralDataContainer
            canWrite={canWrite && newFinancialProductState.editableYN}
            productId={productId}
            onRedirect={onRedirect}
            onChangeTitle={onChangeTitle}
            setGeneralDataLens={setGeneralDataLens}
          />
          <FinancialProductDetailsContainer
            canWrite={canWrite && newFinancialProductState.editableYN}
            data={data?.financialProduct}
            productId={productId}
            isSaved={productId !== undefined && productId !== null}
            generalDataLens={generalDataLens}
          />
        </>
      )}
    </>
  );
};

FinancialProductContainer.propTypes = {
  canWrite: PropTypes.bool,
  productId: PropTypes.number,
  onRedirect: PropTypes.func,
  onChangeTitle: PropTypes.func
};

export default FinancialProductContainer;
